import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';

import { ApiOrganization } from '../../get';

const getPath = (uid: string) => `/v1/organizations/${uid}/competitions`;

export async function apiGetV1OrganizationByIdCompetitions(uid: string) {
  if (!uid) return [];
  const response = await request.GET<{ competitions: ApiCompetitionShow[] }>(getPath(uid));
  return response.competitions;
}

export function useSWRV1OrganizationByIdCompetitions(uid: string) {
  const swr = useSWR(
    getPath(uid),
    () => apiGetV1OrganizationByIdCompetitions(uid),
    SWR_GLOBAL_CONFIG,
  );
  return { ...swr, competitions: swr.data };
}

/** railsの`app/serializers/v1/competition_serializers/show.rb`に該当 */
export type ApiCompetitionShow = ApiCompetition & {
  most_voted_organization?: ApiOrganization;
};

/** railsの`app/serializers/v1/competition_serializers/[index.rb|base.rb]`に該当 */
export type ApiCompetition = {
  id: number;
  cover?: string;
  status: 'open' | 'voting' | 'finished';
  public: boolean;
  updated_at: string;
  schedules: string[];
  amount: string;
  vote_count_visible: boolean;
  presentations: CompetitionPresentation[];
  title?: string;
  corporate: Corporate;
  social_issue: SocialIssue;
};

type Corporate = {
  id: number;
  uid: string;
  logo: string;
  cover?: string;
  materiality: string;
  name: string;
  title: string;
  sdgs: number[];
  category: string;
  category_postfix: boolean;
  business: string;
  social_vision: string;
  interest: string;
  homepage: string;
};

type CompetitionPresentation = {
  id: number;
  video?: string;
  title: string;
  description?: string;
  slide?: string;
  slide_video?: string;
  thumbnail?: string;
  votes: number;
  comments: number;
  voted: boolean;
  any_voted: null;
  votable: null;
  competition_id: null;
  organization: Organization;
};

type Organization = {
  id: number;
  uid: string;
  name: string;
  logo: string;
  category: string;
  area: string;
  cover: string;
  sdgs: number[];
  tags: Tag[];
  vision: string;
  mission: string;
  links: Link[];
  social_issue: string;
  activity?: string;
  activity_image: string;
  performance: string;
  owner: string;
  owner_title: string;
  owner_image?: string;
  since: string;
  postal_code: string;
  address: string;
  budget: string;
  full_time_staff: string;
  part_time_staff: string;
  volunteer: string;
  client: string;
  prefecture: string;
  presentations: OrganizationPresentation[];
};

type Link = {
  name: string;
  url: string;
};

type OrganizationPresentation = {
  id: number;
  video?: string;
  title: string;
  description?: string;
  slide?: string;
  slide_video?: string;
  organization_id: number;
  competition_id: null;
  created_at: string;
  updated_at: string;
  public?: boolean;
};

type Tag = {
  id: number;
  name: string;
};

type SocialIssue = {
  id: number;
  name: string;
  color?: string;
  image?: string;
  sdgs?: number[];
  description?: string;
  type?: string;
  font_color?: string;
  title?: string;
  display_name?: string;
  created_at: string;
  sdgs_score?: number[];
  social_issue_category?: SocialIssueCategory;
};

type SocialIssueCategory = {
  id: number;
  name: string;
  color: string;
};
